var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"stroke":"#525D70","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M10.667 2.668H6a2 2 0 0 0-1.886 2.667M9.334 8a2.667 2.667 0 0 1 0 5.334H4M2.667 8h10.667"}})])
}
var staticRenderFns = []

export default { render: render }